import { createGlobalStyle } from 'styled-components';

const globalStyles = createGlobalStyle`
  .swal2-container {
    z-index: ${({ theme }) => theme.zIndex.modal} !important;
  }
`;

export default globalStyles;
